<template>
  <bdg-input-template
    :name="name"
    :required="required"
    :invalid="isInvalid"
    :loading="loading"
    @focusout="onFocusout"
  >
    <dropdown
      ref="dropdown"
      :class="{ invalid: isInvalid }"
      :options="options"
      :placeholder="placeholder"
      :searchable="searchable"
      :empty-state-text="emptyStateText"
      :search-text="computedSearchText"
      @search-input="setSearchText"
      @blur="$emit('blur')"
      v-model="computedValue"
      v-if="!loading"
    />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import Dropdown from "./Dropdown";
import { optionsValidator } from "../../validators/options-validator";

export default {
  name: "BdgDropdown",
  extends: BdgInputTemplate,
  components: { Dropdown, BdgInputTemplate },
  props: {
    value: [String, Number],
    searchText: [String, Number],
    placeholder: String,
    options: {
      type: [Array, Object],
      validator: optionsValidator
    },
    emptyStateText: String,
    searchable: Boolean
  },
  data() {
    return {
      localSearchText: undefined
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    computedSearchText: {
      get() {
        if (typeof this.searchText !== "undefined") {
          return this.searchText;
        }
        return this.localSearchText;
      },
      set(val) {
        this.localSearchText = val;
        this.$emit("search-input", val);
      }
    },
    isValid() {
      if (
        typeof this.computedValue === "string" ||
        (this.searchable && typeof this.computedSearchText === "string")
      ) {
        return (
          (this.computedValue && this.computedValue.length) ||
          (this.computedSearchText && this.computedSearchText.length)
        );
      }
      return (
        typeof this.computedValue === "number" ||
        typeof this.computedSearchText === "number"
      );
    }
  },
  methods: {
    onFocusout() {
      this.isInvalid = this.required && !this.isValid;
    },
    setSearchText(text) {
      if (typeof this.searchText === "undefined") {
        this.localSearchText = text;
      } else {
        this.computedSearchText = text;
      }
    }
  }
};
</script>

<style scoped></style>
